import { dataFileAlt } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFileAlt = /*#__PURE__*/createIcon(dataFileAlt)
export default IconFileAlt
